import React from "react";

import {
    Autocomplete,
    Button,
    FilterRemoveIcon,
    Heading,
    IconButton,
    Pane,
    SelectField,
    TextInputField,
    Tooltip
} from "evergreen-ui";
import {useDispatch, useSelector} from "react-redux";
import {equationsSelector, selectorStationsForFilters} from "../periodValuesFilterApi";
import {findFirstByName} from "../common/matchMethods";
import {selectLevelCode, selectRainfallCode, selectStation} from "./riverFloodSlice";
import {getDatasourceTypesByStation} from "../decadeConstructor/ApiCalls";
import {getRiverFloodConstructorRights} from "../../Privileges/PrivilegesSelectors";
import FloodFilterPanel from "../flood/common/FloodFilterPanel";
import {
    addNewFilter,
    deleteFilter,
    selectCatchmentArea,
    selectCoefficientA,
    selectCoefficientB,
    selectCoefficientC,
    selectCoefficientD,
    selectEquation,
    selectLevelDatasourceType,
    selectLevelEntity,
    selectRainfallDatasourceType,
    selectRainfallEntity,
    setNewRiverFloodConstructor
} from "../riverFlood/riverFloodSlice";
import CoefficientsComponent, {
    checkCoefficients,
    checkCoefficientsWithoutPush
} from "../flood/common/CoefficientsComponent";
import CreateTemplateDialog from "../common/CreateTemplateDialog";
import {saveRiverTemplate} from "../rainFlood/ApiCalls";
import {floodObject} from "../flood/model/FloodObjects";
import RiverFloodSpringTable from "./RiverFloodSpringTable";
import RiverFloodSnowTable from "./RiverFloodSnowTable";
import CreateOutputFormRiverFloodDialog from "./CreateOutputFormRiverFloodDialog";
import {createFullStationName, createFullStationNameWithOuterIdx} from "../Constructor.DefaultPage";
import {AutoCompleteConstructor} from "../../BaseConstructor/BaseConstructor";

export default function RiverFloodPage({isFullInfo, isEdit}) {
    const dispatch = useDispatch();
    const privileges = useSelector(state => state.login.privileges)

    const rights = getRiverFloodConstructorRights(privileges)

    const stations = useSelector(selectorStationsForFilters);
    const equations   = useSelector(equationsSelector);


    const [isFormShown, setIsShown] = React.useState(false)
    const riverFloodConstructor = useSelector(state => state.riverFloodConstructor)
    const [createTemplateShown, setCreateTemplateShown] = React.useState(false)
    const setCreateTemplateShownCallback = (shown) => setCreateTemplateShown(shown)

    const setIsShownCallback = (shown) => setIsShown(shown)

    const [dsourceTypes, setDsourceTypes] = React.useState([])

    const [idx, setIdx] = React.useState(chooseIdx())

    function chooseIdx() {
        for (let i = 0; i < stations.length; i++) {
            if (stations[i].name === riverFloodConstructor.station.name)
                return stations[i].idx
        }
        return undefined
    }

    function isEquationDisabled() {
        return riverFloodConstructor.filters[riverFloodConstructor.filters.length - 1].level.code.id === -1
    }

    function isCreateTemplateDisabled() {
        return !(riverFloodConstructor.station.id !== -1
            && riverFloodConstructor.filters[riverFloodConstructor.filters.length - 1].level.code.id !== -1
            && riverFloodConstructor.filters[riverFloodConstructor.filters.length - 1].rainfall.code.id !== -1
            && riverFloodConstructor.equation !== "-1"
            && riverFloodConstructor.equation !== ""
            && riverFloodConstructor.catchmentArea !== ""
            && checkCoefficientsWithoutPush(riverFloodConstructor.coefficients, riverFloodConstructor.equation)
        )
    }

    function isOutputFormDisabled() {
        return isCreateTemplateDisabled()
    }

    function onSelectStation(selectedItem) {
        clearFilter()
        setIdx(
            selectedItem.split("] ")[0]
                .replace("[", "")
        )
        selectedItem = selectedItem.split("] ")[1]
        let res = findFirstByName(stations, selectedItem)

        getDatasourceTypesByStation(res.id).then((result) => {
            setDsourceTypes(result.data)
            res = {id: res.id, name: res.name, sourcesTypes: result.data}
            dispatch(selectStation(res));
        })
    }

    function clearFilter() {
        dispatch(setNewRiverFloodConstructor({...floodObject}))
    }

    return (
        <Pane display="block"  marginBottom={80}>
            <Heading size={600}>Конструктор "Половодье"</Heading>

            <Pane display="flex" columnGap={10} marginBottom={45} marginTop={5}>
                <Pane>
                    <Pane marginBottom={5}>
                        Станция
                    </Pane>
                    {AutoCompleteConstructor(
                        onSelectStation,
                        riverFloodConstructor,
                        idx,
                        stations,
                        isFullInfo,
                        createFullStationNameWithOuterIdx,
                        createFullStationName
                    )}
                </Pane>
            </Pane>

            <FloodFilterPanel isFullInfo={isFullInfo}
                              constructor={riverFloodConstructor}
                              onAddFilter={() => dispatch(addNewFilter())}
                              onDeleteFilter={deleteFilter}
                              onSelectDatasourceTypeForRainfall={selectRainfallDatasourceType}
                              onSelectDatasourceTypeForLevel={selectLevelDatasourceType}
                              onSelectEntityForRainfall={selectRainfallEntity}
                              onSelectEntityForLevel={selectLevelEntity}
                              onSelectCodeForRainfall={selectRainfallCode}
                              onSelectCodeForLevel={selectLevelCode}
            />

            <Pane display={'flex'} columnGap={80}>
                <Pane marginTop={3}>
                    <SelectField disabled={isEquationDisabled() || isFullInfo}
                                label={"Уравнение для расчета расхода воды"}
                                 value={riverFloodConstructor.equation}
                                 onChange={e => dispatch(selectEquation(e.target.value))}
                    >
                        <option value={-1}>Выберите уравнение</option>
                        {equations.map(eq => <option value={eq.equationString}>{eq.equationString}</option>)}
                    </SelectField>
                </Pane>
                <Pane>
                    <CoefficientsComponent
                        isFullInfo={isFullInfo}
                        coefficients={riverFloodConstructor.coefficients}
                        onSelectA={selectCoefficientA}
                        onSelectB={selectCoefficientB}
                        onSelectC={selectCoefficientC}
                        onSelectD={selectCoefficientD}
                    />
                </Pane>
            </Pane>

            <TextInputField
                label={"Площадь водосбора"}
                type={"number"}
                step={"any"}
                disabled={isEquationDisabled() || isFullInfo}
                onChange={e => dispatch(selectCatchmentArea(e.target.value))}
                value={riverFloodConstructor.catchmentArea}
                width={220}
                marginTop={10}
                placeholder="Площадь водосбора"
            />

            {
                !isFullInfo && !isEdit?
                    <Pane>
                        {
                            rights.canSaveTemplate ?
                                isCreateTemplateDisabled() ?
                                    <Tooltip content={"Выберите фильтры"}>
                                        <Pane display={"inline"}>
                                            <Button marginRight={10}
                                                    marginTop={10}
                                                    disabled={true}>Сохранить шаблон</Button>
                                        </Pane>
                                    </Tooltip> :
                                    <Button marginRight={10}
                                            marginTop={10}
                                            onClick={() => {if (checkCoefficients(riverFloodConstructor.coefficients, riverFloodConstructor.equation)) setCreateTemplateShown(true)}}
                                            disabled={false}>Сохранить шаблон</Button>

                                : <></>
                        }
                        {
                            rights.canCreateOutputForm ?
                                isOutputFormDisabled() ?
                                    <Tooltip content={"Выберите фильтры"}>
                                        <Pane display={"inline"}>
                                            <Button disabled={true} marginTop={10}>Выгрузить выходную форму</Button>
                                        </Pane>
                                    </Tooltip> :
                                    <Button onClick={() => {if (checkCoefficients(riverFloodConstructor.coefficients, riverFloodConstructor.equation)) setIsShown(true); }}
                                            disabled={false}
                                            marginTop={10}>Выгрузить выходную форму</Button>
                                : <></>
                        }
                        <Tooltip content="Сбросить">
                            <IconButton marginTop={10} marginLeft={10} icon={FilterRemoveIcon} onClick={() => clearFilter()}/>
                        </Tooltip>

                    </Pane> : <></>

            }


            {
                !isFullInfo && !isEdit? <>
                    <RiverFloodSpringTable/>
                    <RiverFloodSnowTable/>
                </> : <></>
            }



            <CreateOutputFormRiverFloodDialog
                constructor={riverFloodConstructor}
                isShown={isFormShown}
                setIsShown={setIsShownCallback}
                viaTemplateId={false}
                name={""}
            />


            <CreateTemplateDialog isShown={createTemplateShown}
                                  setIsShown={setCreateTemplateShownCallback}
                                  createTemplate={(templateName) => saveRiverTemplate(riverFloodConstructor, templateName)}
            />


        </Pane>
    )

}
